module.exports = "/_next/static/images/instrument_3-fde42469c1c01ee38713e18f26c28016.png";